import { render, staticRenderFns } from "./RemoveDialog.vue?vue&type=template&id=7bd0e63a&scoped=true"
import script from "./RemoveDialog.vue?vue&type=script&lang=js"
export * from "./RemoveDialog.vue?vue&type=script&lang=js"
import style0 from "./RemoveDialog.vue?vue&type=style&index=0&id=7bd0e63a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd0e63a",
  null
  
)

export default component.exports